import { HubConnection } from '@microsoft/signalr';
import { useContext } from 'react';

import { HUB_URL } from '../const';
import { HubContext } from './SignalRHubProvider';
import { useHubConnection } from './useHubConnection';

export type UseHubConnection = ReturnType<typeof useHubConnection>;

/**
 * Hook to use for the Iothub hub
 */
export function useSignalRHub(
  url: HUB_URL,
  /**
   * Refactor this - its a unhandy way for invoking methods on startup -
   * it should be have a bedder name at least to describe what this does cause general invokes are different
   */
) {
  const context = useContext(HubContext);

  // this helps with not having undefined/null types later https://react-typescript-cheatsheet.netlify.app/docs/basic/getting-started/context/
  if (!context) {
    throw new Error('Error: HubContext has to be used inside a <HubProvider>');
  }

  const hubContext = context[url];
  if (!hubContext) {
    throw new Error('Error: HubContext not initialised - Provider should protect user for access');
  }

  // we override the connection type because all invokes/subscribes throw if no connection not exist.
  const connection = hubContext.connection as HubConnection;
  // if (!connection) {
  //   throw new Error('Error: connection not initialised - Provider should protect user for access');
  // }

  return { ...hubContext, connection, hubUrl: url };
}

export type SignalRHub = ReturnType<typeof useSignalRHub>;
